import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";
import { CDN_BASE_URL } from "../../../config";
import { Link } from "react-router-dom";

const BlogsRelatedMobile = ({ related }) => {
  const [blogs, setBlogs] = useState([]);
  const [slider, setslider] = useState();
  const [loading, setloading] = useState();

  useEffect(() => {
    getData();
  }, []);



  async function getData() {
    setloading(true);
    await httpReauest("GET", `/blog?limit=10${related ? "&related=" + related : ""}`, {}, {}).then(({ data }) => {
      setBlogs(data?.data);
    });

    setloading(false);
  }

  if (loading) {
    return (
      <div className="w-full flex justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <>
      {blogs?.map((e, i) => {
        if (
          i === 0 ||
          i === 1 ||
          i === 2 ||
          i % 10 === 0 ||
          i % 10 === 1 ||
          i % 10 === 2
        ) {
          return (
            <Link to={"/blogs/" + e?.url} className="col-span-2 row-span-2">
              <img
                className="w-full object-cover rounded-[8px] h-[29vw]"
                src={CDN_BASE_URL + e?.cover}
                alt={e?.name}
                title={e?.name}
              />
            </Link>
          );
        } else if (i === 3 || i === 4 || i % 10 === 3 || i % 10 === 4) {
          return (
            <Link to={"/blogs/" + e?.url} className="col-span-3 row-span-1">
              <img
                className="w-full object-cover rounded-[8px] h-[35vw]"
                src={CDN_BASE_URL + e?.cover}
                alt={e?.name}
                title={e?.name}
              />
            </Link>
          );
        } else if (i === 5 || i === 6 || i % 10 === 5 || i % 10 === 6) {
          return (
            <Link to={"/blogs/" + e?.url} className="col-span-2 row-span-1">
              <img
                className="w-full object-cover rounded-[8px] h-[29vw] "
                src={CDN_BASE_URL + e?.cover}
                alt={e?.name}
                title={e?.name}
              />
            </Link>
          );
        } else if (i === 7 || i % 10 === 7) {
          return (
            <Link to={"/blogs/" + e?.url} className="col-span-2 row-span-2">
              <img
                className="w-full object-cover rounded-[8px] h-full "
                src={CDN_BASE_URL + e?.cover}
                alt={e?.name}
                title={e?.name}
              />
            </Link>
          );
        } else if (i === 8 || i === 9 || i % 10 === 8 || i % 10 === 9) {
          return (
            <Link to={"/blogs/" + e?.url} className="col-span-2 row-span-1">
              <img
                className="w-full object-cover rounded-[8px] h-[29vw]"
                src={CDN_BASE_URL + e?.cover}
                alt={e?.name}
                title={e?.name}
              />
            </Link>
          );
        }
      })}
    </>
  );
};

export default BlogsRelatedMobile;
